module.exports = __webpack_public_path__ + "static/media/cowbell-more.bce009fc.svg";